import css from 'styled-jsx/css';

const styles = css`@import "./styles/global-variables";

.plpBannerImage {
  img {
    max-width: 100%;
  }
}
.productCategory {
  h1 {
    color: $purple-darker;
    font-size: 40px;
    font-family: "Noto Sans JP";
    font-weight: 500;
    padding: 80px 0 40px;

    @media (max-width: $breakpoint-max-md-ipad) {
      font-size: 24px;
    }
  }
  .product-list-container {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: baseline;
    flex-wrap: wrap;    
  }  
}

.product-list-table-img-div {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.prodSpan {
  text-align: center;
  background-color: #64369F;
  border-radius: 9px;
  display: inline-block;
  min-width: 60%;
  color: #FFFFFF;
  margin: 5px;
}

.prodJumpBg1 {
  background-color: #EDECED;
  padding: 0px;
}

.prodJumpBg2 {
  background-color: #F1EBF6;
}

.prodJumpBg3 {
  background-color: #FBCEE2;
  border-left:2px solid #64369F;
}

.prodJumpBg4 {
  background-color: #F8B7D5;
  border-left:2px solid #64369F;
}

.prodJumpBg5 {
  background-color: #C9B4DE;
  border-left:2px solid #64369F;
}

.prodJumpBg6 {
  background-color: #A6E3BD;
  border-left:2px solid #64369F;
} 

.prodJumpBg7 {
  background-color: #FFFFFF;
} 

.product-list-jump1 table {
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
  text-align: center;
  border-radius: 12px;
  overflow: hidden; 
  margin: 50px 0;
  font-weight: bold;
  color: #64369F;
  font-size: 14px;
  line-height: 20px;
  font-family: "Noto Sans JP";

  @media (min-width: $breakpoint-ipad-max) and (max-width: $breakpoint-dt-max) {
      font-size: 28px;
      line-height: 44px;
    }

}

.product-list-jump1 th, td {
  padding: 10px;
  vertical-align: middle;
  border-top:2px solid #64369F;
  border-right:2px solid #64369F;
}

.product-list-jump1 th {
  background-color: #f2f2f2;
}

.product-list-jump1 thead th:first-child {
  border: none;
  border-top-left-radius: 12px;
  background: none;
}

.product-list-jump1 thead th:nth-child(2) {
  border-top-left-radius: 12px;
  border-left:2px solid #64369F;
}

.product-list-jump1 tbody tr:first-child td:first-child {
  border-top-left-radius: 12px;
}

.product-list-jump1 thead th:last-child {
  border-top-right-radius: 12px;
}

.product-list-jump1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 12px;
}

.product-list-jump1 tr:last-child td {
  border-bottom:2px solid #64369F;
}

.product-list-jump1 tr:last-child td:last-child,
.product-list-jump1 tr:last-child td:last-child div{
  border-bottom-right-radius:11px;
}

.tab-container {
  .plpCategoryTab {
    margin-right: 20px;
    background-color: #fff;
    border: 1px solid $purple-darker;
    border-radius: 22px;
    font-size: 18px;
    font-family: 'Noto Sans JP';
    font-weight: 500;
    color: $purple-darker;
    padding: 5px 20px;

    @media (max-width: $breakpoint-ipad-max) {
      margin-bottom: 16px;
      font-size: 14px;
    }

    &.active {
      background-color: $purple-darker;
      color: #fff;
    }
  }
}`;

export default styles;